import { defineStore } from 'pinia'
import { store } from '@/store'

type LocationTypes = {
  name: string
}

interface HomeState {
  location: LocationTypes
  loading: boolean
}

export const useHomeStore = defineStore({
  id: 'home',
  state: (): HomeState => ({
    location: { name: '地区' },
    loading: false,
  }),
  actions: {
    setLocation(location: LocationTypes) {
      this.location = location
    },
    setLoading(value: boolean): void {
      this.loading = value
    },
  },
})

// 在组件setup函数外使用
export function useHomeStoreWithOut() {
  return useHomeStore(store)
}
